import React from 'react';
import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent as fbLogEvent, setUserProperties as fbSetUserProperties, setUserId as fbSetUserId, setCurrentScreen as fbSetCurrentScreen } from 'firebase/analytics';
import { getPerformance, trace } from 'firebase/performance';
import { getRemoteConfig, getValue, fetchConfig, activate } from 'firebase/remote-config';
import { getConfig } from './config';
const app = initializeApp(getConfig());
const analytics = getAnalytics(app);
const performance = getPerformance(app);
const remoteConfig = getRemoteConfig(app);
remoteConfig.settings.minimumFetchIntervalMillis = 3600000; // 1 hour

export const logEvent = (...args) => {
  // @ts-expect-error expect typechecking from AnalyticEvents
  fbLogEvent(analytics, ...args);
};
export const setUserProperties = properties => {
  fbSetUserProperties(analytics, properties);
};
export const setUserId = id => {
  fbSetUserId(analytics, id);
};
export const setCurrentScreen = screenName => {
  fbSetCurrentScreen(analytics, screenName);
};
export const makePerfTrace = name => {
  return trace(performance, name);
};

const getFeatureToggleFunctions = (() => {
  let activated = false;
  const caches = []; // activate cached config

  activate(remoteConfig).then(() => {
    activated = true;
    caches.forEach(resolve => resolve());
    fetchConfig(remoteConfig); // fetch config for next launch
  });

  const syncGet = name => {
    return activated ? getValue(remoteConfig, name).asString() : '';
  };

  const asyncGet = async name => new Promise(resolve => {
    if (activated) {
      resolve(syncGet(name));
    } else {
      caches.push(() => {
        resolve(syncGet(name));
      });
    }
  });

  return {
    syncGet,
    asyncGet
  };
})();

export const getFeatureToggleSync = getFeatureToggleFunctions.syncGet;
export const getFeatureToggle = getFeatureToggleFunctions.asyncGet;
export const useFeatureToggle = (key, defaultValue) => {
  const [value, setValue] = React.useState(defaultValue);
  React.useEffect(() => {
    getFeatureToggle(key).then(setValue);
  }, [key]);
  return value;
};
export const useFeatureToggleWithLoading = (key, defaultValue) => {
  const currentKey = React.useRef(key);
  const [value, setValue] = React.useState(defaultValue);
  const [loading, setLoading] = React.useState(true);
  React.useEffect(() => {
    setValue(defaultValue);
    setLoading(true);
    currentKey.current = key;
    getFeatureToggle(key).then(result => {
      if (currentKey.current !== key) {
        return;
      }

      setValue(result);
      setLoading(false);
    });
  }, [key, defaultValue]);
  return [value, loading];
};